// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GOfO3","rootNoMargin":"styles_rootNoMargin__12snP"};